export const INITIAL_CONTEXT = {
  data: null,
  setData: () => null,
};
